import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.pick.pickFollowUpActionsDialog.title',
    defaultMessage: 'Finished picking',
    description: 'Title of the follow up actions dialog',
  },
  message: {
    id: 'pages.pick.pickFollowUpActionsDialog.message',
    defaultMessage:
      'You have finished picking all items. Would you like to pack the products or start picking another shipment?',
    description: 'Message of the follow up actions dialog',
  },
  actions: {
    shipments: {
      id: 'actions.shipments',
      defaultMessage: 'Shipments',
      description: 'Label of the shipments action of the follow up actions dialog',
    },
    pack: {
      id: 'actions.pack',
      defaultMessage: 'Pack',
      description: 'Label of the pack action of the follow up actions dialog',
    },
  },
};

export default defineMessages(translations);
